// extracted by mini-css-extract-plugin
export default {"v-application":"CatalogCartBtn_v-application_D7G0b","text-h1":"CatalogCartBtn_text-h1_k9SqO","text-h2":"CatalogCartBtn_text-h2_IXKaD","btn":"CatalogCartBtn_btn_pDCFW"};